import { Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const ContextScrollPositionRecord = Record({
  mainViewLeftTs: null,
  mainViewRightTs: null,
  scrollLeftTs: null,
  unitScale: null,
  contextUnitScale: null,
  animate: false
});

createFromJS.registerCallback(
  "ContextScrollPositionRecord",
  createFromJS.createPrimitiveCallback(ContextScrollPositionRecord)
);
